import React, { useRef } from "react";
import { Star, Quote, ChevronLeft, ChevronRight } from "lucide-react";
import { siteConfig as fallback } from "../mock";
import { useSite } from "../context/SiteContext";
import { img } from "../lib/api";

const Reviews = () => {
  const { settings } = useSite();
  const s = settings || fallback;
  const reviews = s.reviews || [];
  const trackRef = useRef(null);

  const scroll = (dir) => {
    const el = trackRef.current;
    if (el) el.scrollBy({ left: dir * (el.clientWidth * 0.8), behavior: "smooth" });
  };

  return (
    <section id="reviews" className="bg-navy py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="reveal text-center max-w-2xl mx-auto mb-14">
          <p className="text-gold text-sm font-semibold tracking-widest uppercase mb-3">Real Customer Feedback</p>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white">Loved by Creators</h2>
          <div className="mt-5 inline-flex items-center gap-2">
            <div className="flex">{[...Array(5)].map((_, i) => (<Star key={i} size={18} className="fill-gold text-gold" />))}</div>
            <span className="text-slate-300 text-sm">{s.rating} from {s.reviewCount} reviews</span>
          </div>
        </div>

        <div className="relative">
          <div ref={trackRef} className="flex gap-6 overflow-x-auto snap-x snap-mandatory pb-4 scroll-smooth" style={{ scrollbarWidth: "none" }}>
            {reviews.map((r, idx) => (
              <div key={idx} className="snap-start shrink-0 w-[85%] sm:w-[360px] bg-navy-800 rounded-2xl p-7 border border-white/10 relative">
                <Quote size={40} className="text-gold/20 absolute top-5 right-5" />
                <div className="flex mb-4">{[...Array(r.rating || 5)].map((_, i) => (<Star key={i} size={15} className="fill-gold text-gold" />))}</div>
                <p className="text-slate-300 leading-relaxed mb-6 min-h-[72px]">&ldquo;{r.text}&rdquo;</p>
                <div className="flex items-center gap-3">
                  {r.avatar ? (
                    <img src={img(r.avatar)} alt={r.name} className="h-11 w-11 rounded-full object-cover" />
                  ) : (
                    <div className="h-11 w-11 rounded-full bg-gradient-to-br from-gold-light to-gold-dark flex items-center justify-center text-navy font-bold text-sm">{r.initials || (r.name || "?").slice(0, 2).toUpperCase()}</div>
                  )}
                  <div>
                    <p className="text-white text-sm font-semibold">{r.name || r.handle}</p>
                    {r.handle && r.handle !== r.name && <p className="text-gold text-xs">{r.handle}</p>}
                  </div>
                </div>
              </div>
            ))}
          </div>
          {reviews.length > 1 && (
            <div className="flex justify-center gap-3 mt-6">
              <button onClick={() => scroll(-1)} className="h-10 w-10 rounded-full border border-gold/30 text-white flex items-center justify-center hover:bg-gold hover:text-navy transition-colors"><ChevronLeft size={18} /></button>
              <button onClick={() => scroll(1)} className="h-10 w-10 rounded-full border border-gold/30 text-white flex items-center justify-center hover:bg-gold hover:text-navy transition-colors"><ChevronRight size={18} /></button>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default Reviews;
